<div [ngClass]="{ 'col-6 col-3--md col-4--sm': !config.fullWidth }">
  <div class="form-group">
    <label
      [for]="config.name"
      [ngClass]="{
        'form-label--error': config.mainControl?.hasError
      }"
      *ngIf="config.label"
    >
      {{ config.label }}
      <span *ngIf="showMandatory">*</span>
    </label>
    <air-password-control
      *ngIf="isPasswordControl && config.mainControl"
      [group]="group"
      [control]="config.mainControl"
      [formState]="formState"
      (changeTrigger)="onMainChange($event)"
    ></air-password-control>
    <air-text-control
      *ngIf="!isPasswordControl && config.mainControl"
      [group]="group"
      [control]="config.mainControl"
      [formState]="formState"
      [userEventSource]="userEventSource"
    ></air-text-control>
  </div>
  <div class="form-error" *ngIf="config.mainControl?.hasError && control.errorMessages?.length">
    <div class="form-error__message" *ngFor="let message of control.errorMessages">
      {{ message }}
    </div>
  </div>
</div>
<div [ngClass]="{ 'col-6 col-3--md col-4--sm': !config.fullWidth }">
  <div class="form-group">
    <label
      [for]="repeatControlName"
      [ngClass]="{
        'form-label--error': config.repeatControl?.hasError
      }"
      *ngIf="config.repeatControlLabel"
    >
      {{ config.repeatControlLabel }}
      <span *ngIf="showMandatory">*</span>
    </label>
    <air-password-control
      *ngIf="isPasswordControl && config.repeatControl"
      [group]="group"
      [control]="config.repeatControl"
      [formState]="formState"
      (changeTrigger)="onRepeatChange($event)"
    ></air-password-control>
    <air-text-control
      *ngIf="!isPasswordControl && config.repeatControl"
      [group]="group"
      [control]="config.repeatControl"
      [formState]="formState"
      [userEventSource]="userEventSource"
    ></air-text-control>
  </div>
  <div class="form-error" [hidden]="!config.repeatControl?.hasError">
    <div class="form-error__message">
      {{ config.repeatErrorMessage }}
    </div>
  </div>
</div>
<div
  *ngIf="config.showValidationChecklist"
  class="form__description form__checklist"
  [ngClass]="{ 'col-12 col-6--md col-4--sm': config.fullWidth === false }"
>
  <p *ngIf="config.validationChecklistTitle">
    <strong>{{ config.validationChecklistTitle }}</strong>
  </p>
  <ng-container *ngFor="let validator of control.validators">
    <div
      [ngClass]="{ 'form__checklist--error': formControl?.touched && validator.hasError, 'form__checklist--valid': !validator.hasError }"
      *ngIf="!validator.hideFromChecklist && validator.errorMessage"
    >
      <i class="icon" *ngIf="formControl?.touched" [ngClass]="validator.hasError ? 'icon-ui-close--sm' : 'icon-ui-checkmark--sm'"></i>
      <i class="icon" *ngIf="!formControl?.touched" [ngClass]="validator.hasError ? 'icon-ui-dot' : 'icon-ui-checkmark--sm'"></i>
      <span>{{ validator.errorMessage }}</span>
    </div>
  </ng-container>
  <div
    [ngClass]="{
      'form__checklist--error': formControl?.touched && formRepeatControl?.touched && repeatCheckHasError,
      'form__checklist--valid': formControl?.touched && !repeatCheckHasError
    }"
  >
    <i
      class="icon"
      *ngIf="formControl?.touched && formRepeatControl?.touched"
      [ngClass]="repeatCheckHasError ? 'icon-ui-close--sm' : 'icon-ui-checkmark--sm'"
    ></i>
    <i
      class="icon"
      *ngIf="!formControl?.touched || !formRepeatControl?.touched"
      [ngClass]="!formControl?.touched || repeatCheckHasError ? 'icon-ui-dot' : 'icon-ui-checkmark--sm'"
    ></i>
    <span>{{ config.repeatChecklistMessage || config.repeatErrorMessage }}</span>
  </div>
</div>
